export const sizes = {
  small: {
    width: 30,
    height: 30,
  },
  large: {
    width: 55,
    height: 55,
  },
};

export const placeholder = "${app.context}/dist/images/avatar.gif";
